import type { ComponentPropsWithoutRef } from 'react';
import { css, cx, keyframes } from '@eti/styles';

interface DotPulseLoaderProps extends ComponentPropsWithoutRef<'div'> {}

const pulse = keyframes`
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
`;

const dotSize = '5px';
const loaderSize = '21px';
const animationSpeed = '1.3s';
const dotColor = 'black';

const containerStyles = css`
  align-items: center;
  display: flex;
  height: ${dotSize};
  justify-content: space-between;
  position: relative;
  width: ${loaderSize};

  &::before,
  &::after {
    background-color: ${dotColor};
    border-radius: 50%;
    content: '';
    display: block;
    height: ${dotSize};
    transform: scale(0);
    transition: background-color 0.3s ease;
    width: ${dotSize};
  }

  &::before {
    animation: ${pulse} ${animationSpeed} ease-in-out calc(${animationSpeed} * -0.375) infinite;
  }

  &::after {
    animation: ${pulse} ${animationSpeed} ease-in-out calc(${animationSpeed} * -0.125) infinite;
  }
`;

const dotStyles = css`
  animation: ${pulse} ${animationSpeed} ease-in-out calc(${animationSpeed} * -0.25) infinite both;
  background-color: ${dotColor};
  border-radius: 50%;
  height: ${dotSize};
  transform: scale(0);
  width: ${dotSize};
`;

const DotPulseLoader = ({ className, ...props }: DotPulseLoaderProps) => (
  <div aria-hidden className={cx(containerStyles, className)} {...props}>
    <div className={dotStyles} />
  </div>
);

export default DotPulseLoader;
